import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { PermissionContext, RolePermissions } from "appContext";
import { pages } from "views/pages/manage/common/constant";
import ALoader from "views/pages/manage/common/a-loader";

import { ReactComponent as RepeatIcon } from "assets/img/svg/MoneyWavyGreen.svg";
import { getScreenCards } from "../../../../views/pages/manage/finOps/IssueStock/search/SearchCard";

const ModuleCards = () => {
  const history = useHistory();
  const Cash_Management_Permission = RolePermissions(
    useContext(PermissionContext),
    pages["cashPaymentManagement"]["id"]
  );

  const Cheque_Management_Permission = RolePermissions(
    useContext(PermissionContext),
    pages["chequePaymentManagement"]["id"]
  );

  const cards = [
    Cash_Management_Permission && {
      heading: "Cash management",
      subHeading: "Track all the raised Cash Managements",
      icon: (
        <span className="iconWrapper">
          <RepeatIcon />
        </span>
      ),
      action: () => {
        history.push("/admin/cash-management");
      },
    },
    Cheque_Management_Permission && {
      heading: "Cheque management",
      subHeading: "Track all the raised Cheque management",
      icon: (
        <span className="iconWrapper">
          <RepeatIcon />
        </span>
      ),
      action: () => {
        history.push("/admin/cheque-management");
      },
    },
  ];
  return (
    <>
      <div className={`screen-cards-container`}>

        {getScreenCards(cards?.filter((card) => card))}
      </div>
    </>
  );
};

export default ModuleCards;
